import React, { useState } from 'react'
import styles from '../../../styles/UAEPageComponents.module.css'
import { Button } from 'reactstrap'
import VerificationPopup from '@/components/modals/VerificationPopup'
import VerificationPopupUAE from '@/components/HomeLanding/HomeLandingComponents/VerificationPopupUAE'

const ContqactSection = ({title, description, buttonText}) => {
  const [demoModal, setDemoModal] = useState(false);
  const [demoModalSales, setDemoModalSales] = useState(false);
  const [formHeading, setFormHeading] = useState("Book your free demo now!");
  const [contactSales, setContactSales] = useState(false);
  
  return (
    <div>
      <div style={{ textAlign: "center", margin: "-2rem 0 2rem 0" }}>
        <VerificationPopupUAE isOpen={demoModalSales} closeModal={() => setDemoModalSales(false)} formHeading={formHeading} contactSales={contactSales} />
        <p style={{ fontSize: "2.8rem", fontFamily: "GilroyBold" }}>{title || "Anything else on your mind ?"}</p>
        <p style={{ margin: "1.2rem 0", fontSize: "1.8rem" }}>{description ||  <>Can't find what you need? <br /> Let our expert team help you.</>}</p>
        <Button className={styles.Connect_specialist_btn} onClick={() => { setDemoModalSales(true); setContactSales(true); setFormHeading("Connect with a specialist"); }}>{buttonText || "Connect with a specialist"}</Button>
      </div>
    </div>
  )
}

export default ContqactSection